export default __webpack_public_path__ + "assets/images/dummy_logo.png";